export default {
  AGREE: 'agree',
  DISAGREE: 'disagree',
  COMPLETE: 'complete',
  RESOLVED: 'resolved',
  ABSENT: 'absent',
};
